// Router. Public: /login, /callback. Everything else is behind RequireAuth + the Layout shell.
// /admin/* additionally requires role=admin (RequireAdmin; server enforces authz regardless).

import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "@/components/RequireAuth";
import { RequireAdmin } from "@/components/RequireAdmin";
import { Layout } from "@/components/Layout";
import { Login } from "@/pages/Login";
import { Callback } from "@/pages/Callback";
import { Account } from "@/pages/Account";
import { LicensePage } from "@/pages/License";
import { Buy } from "@/pages/Buy";
import { Purchases } from "@/pages/Purchases";
import { PurchaseDetail } from "@/pages/PurchaseDetail";
import { Download } from "@/pages/Download";
import { AiConnections } from "@/pages/AiConnections";
import { AdminOverview } from "@/pages/admin/Overview";
import { AdminUsers } from "@/pages/admin/Users";
import { AdminUserDetailPage } from "@/pages/admin/UserDetail";
import { AdminOrders } from "@/pages/admin/Orders";
import { AdminOrderDetailPage } from "@/pages/admin/OrderDetail";
import { AdminLicenses } from "@/pages/admin/Licenses";
import { AdminCoupons } from "@/pages/admin/Coupons";
import { AdminPricing } from "@/pages/admin/Pricing";
import { AdminCommissions } from "@/pages/admin/Commissions";
import { AdminWebhookEvents } from "@/pages/admin/WebhookEvents";
import { AdminAuditLog } from "@/pages/admin/AuditLog";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/callback" element={<Callback />} />

      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Account />} />
        <Route path="license" element={<LicensePage />} />
        <Route path="buy" element={<Buy />} />
        <Route path="purchases" element={<Purchases />} />
        <Route path="purchases/:id" element={<PurchaseDetail />} />
        <Route path="download" element={<Download />} />
        <Route path="koneksi-ai" element={<AiConnections />} />

        <Route path="admin" element={<RequireAdmin />}>
          <Route index element={<AdminOverview />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="users/:id" element={<AdminUserDetailPage />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="orders/:id" element={<AdminOrderDetailPage />} />
          <Route path="licenses" element={<AdminLicenses />} />
          <Route path="pricing" element={<AdminPricing />} />
          <Route path="coupons" element={<AdminCoupons />} />
          <Route path="commissions" element={<AdminCommissions />} />
          <Route path="webhooks" element={<AdminWebhookEvents />} />
          <Route path="audit" element={<AdminAuditLog />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
